import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BrandMark } from "@/components/AppShell";
import { txt, useMaintenance } from "@/content/ContentContext";

export function MaintenanceGate({ children }) {
  return useMaintenance() ? <MaintenancePage /> : children;
}

function MaintenancePage() {
  return (
    <div className="grain relative flex min-h-[100dvh] flex-col overflow-hidden bg-slate-950 text-white" data-testid="maintenance-page">
      <header className="border-b border-white/5">
        <div className="mx-auto flex h-16 max-w-7xl items-center px-4 sm:px-8"><BrandMark /></div>
      </header>
      <main className="mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-4 pb-24 pt-14 sm:px-8">
        <div className="inline-flex w-fit items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1 font-mono text-[11px] uppercase tracking-[0.25em] text-amber-400" data-testid="maintenance-eyebrow">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-amber-400" />{txt("maintenance.eyebrow")}
        </div>
        <h1 className="mt-6 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-testid="maintenance-message">{txt("maintenance.message")}</h1>
        <p className="mt-6 max-w-md text-lg text-slate-400" data-testid="maintenance-note">{txt("maintenance.note")}</p>
        <Link to="/login" className="mt-9 flex h-12 w-fit items-center gap-2 rounded-xl bg-amber-500 px-6 font-bold text-slate-950 transition-colors hover:bg-amber-400" data-testid="maintenance-login">
          {txt("maintenance.login")} <ArrowRight className="h-4 w-4" />
        </Link>
      </main>
    </div>
  );
}
